import { useEffect, useRef } from 'react'

export function useInterval(
  delay: number | undefined,
  callback: () => void,
): void {
  const savedCallback = useRef(() => {})

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick(): void {
      savedCallback.current()
    }
    if (delay !== undefined) {
      const id = setInterval(tick, delay)
      return () => {
        clearInterval(id)
      }
    }
  }, [delay])
}
